// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"17275":"10258e3eb7d37fca","67940":"5093d1c5bd5c7d8a"}[chunkId] + ".css";
};